// import { Swiper, Pagination } from "swiper/dist/js/swiper.esm.js";
import Swiper, { Pagination } from "swiper/core";

Swiper.use([Pagination]);

export default class CarouselSwiper {
  constructor() {
    this.carousels = document.querySelectorAll(".jsCarousel");
    if (this.carousels) this.init();
  }

  setCarousel(i, config) {
    new Swiper(i, config);
  }

  init() {
    for (let i = 0; i < this.carousels.length; i++) {
      let config = {};

      if (this.carousels[i].classList.contains("jsNewsTickerTiles")) {
        config = {
          slidesPerView: 2,
          spaceBetween: 20,
          // breakpoints: {
          //   767: {
          //     slidesPerView: "auto",
          //     slidesOffsetBefore: 45,
          //     slidesOffsetAfter: 45,
          //     pagination: {
          //       el: this.carousels[i].parentElement.querySelector(".jsCarouselDots"),
          //       clickable: true,
          //       renderBullet: (index, className) =>
          //         '<span class="carousel-bullet__item ' + className + '"></span>'
          //     }
          //   },
          //   1023: {
          //     slidesPerView: 1,
          //     slidesOffsetBefore: 0,
          //     slidesOffsetAfter: 0,
          //   }
          // }
        };
      } else if (this.carousels[i].classList.contains("jsCarouselSimply")) {
        config = {
          slidesPerView: "auto",
          spaceBetween: 20,
          breakpoints: {
            767: {
              slidesPerView: "auto"
            },
            1023: {
              slidesPerView: 2,
              pagination: {
                el: this.carousels[i].parentElement.querySelector(".jsCarouselDots"),
                clickable: true,
                renderBullet: (index, className) =>
                  '<span class="carousel-bullet__item ' + className + '"></span>'
              }
            },
            3000: {
              slidesPerView: 3
            }
          }
        };
      } else if (this.carousels[i].classList.contains("jsCarouselSimply4")) {
        config = {
          slidesPerView: "auto",
          spaceBetween: 20,
          breakpoints: {
            767: {
              slidesPerView: "auto",
              pagination: {
                el: this.carousels[i].parentElement.querySelector(".jsCarouselDots"),
                clickable: true,
                renderBullet: (index, className) =>
                  '<span class="carousel-bullet__item ' + className + '"></span>'
              }
            },
            1023: {
              slidesPerView: 3,
              pagination: {
                el: this.carousels[i].parentElement.querySelector(".jsCarouselDots"),
                clickable: true,
                renderBullet: (index, className) =>
                  '<span class="carousel-bullet__item ' + className + '"></span>'
              }
            },
            3000: {
              slidesPerView: 4
            }
          }
        };
      } else if (this.carousels[i].classList.contains("jsCarouselOffset")) {
        config = {
          slidesPerView: "auto",
          spaceBetween: 20,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
          breakpoints: {
            767: {
              slidesPerView: "auto"
            },
            1023: {
              slidesPerView: 2,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              pagination: {
                el: this.carousels[i].parentElement.querySelector(".jsCarouselDots"),
                clickable: true,
                renderBullet: (index, className) =>
                  '<span class="carousel-bullet__item ' + className + '"></span>'
              }
            },
            3000: {
              slidesPerView: this.carousels[i].dataset.row
                ? parseInt(this.carousels[i].dataset.row)
                : 3,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            }
          }
        };
      } else {
        config = {
          slidesPerView: "auto",
          spaceBetween: 20,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
          pagination: {
            el: this.carousels[i].parentElement.querySelector(".jsCarouselDots"),
            clickable: true,
            renderBullet: (index, className) =>
              '<span class="carousel-bullet__item ' + className + '"></span>'
          }
        };
      }
      this.setCarousel(this.carousels[i], config);
    }
  }
}
